{
  "accountantConfirmation": "Accountant confirmation",
  "accountantDelivered": "Delivered",
  "admission": "Admission",
  "active": "Active",
  "added": "Added",
  "address": "Address",
  "advisor": "Advisor",
  "billNumber": "Bill nr.",
  "budget": "Budget",
  "category": "Category",
  "city": "City",
  "contactPerson": "Contact person",
  "contactStatus": "Contact status",
  "contractStart": "Contract start",
  "county": "County",
  "deactivatedDate": "Deactivated date",
  "deductible": "Deductible",
  "delivered": "Delivered",
  "description": "Description",
  "dueDate": "Due date",
  "email": "Email",
  "endDate": "End date",
  "ended": "Ended",
  "establishedDate": "Established date",
  "eventDate": "Event date",
  "eventName": "Event name",
  "firstName": "First name",
  "focusArea": "Focus area",
  "focusAreas": "Focus areas",
  "gender": "Gender",
  "hourRate": "Hour rate",
  "hours": "Hours",
  "id": "ID",
  "ideaName": "Idea name",
  "inkind": "In kind",
  "inkindStatus": "In kind status",
  "innovationSupport": "Innovation support",
  "innovation-support": "Innovation support",
  "interestAreas": "Interest areas",
  "international": "International",
  "invitationStatus": "Invitation status",
  "lastName": "Last name",
  "lastChangedDate": "Last changed",
  "mainContact": "Main contact",
  "mainContactEmail": "Main contact email",
  "mainGoal": "Main goal",
  "markAllRows": "Toggle all rows",
  "marketValue": "Market value",
  "markRow": "Toggle row {{index}}",
  "member": "Member",
  "memberCompany": "Member company",
  "memberSince": "Member since",
  "municipalities": "Municipalities",
  "name": "Name",
  "numberOfEmployees": "Number of employees",
  "numberOfParticipants": "No. of participants",
  "organizationNumber": "Organization number",
  "participants": "Participants",
  "phase": "Phase",
  "phone": "Phone",
  "postalCode": "Zip code",
  "projectLeader": "Project Leader",
  "projectName": "Project Name",
  "resourceBaseContact": "Resource base contact",
  "responsible": "Responsible",
  "retired": "Retired",
  "retiredDate": "Retired date",
  "roles": "Roles",
  "selfEffort": "Self-effort",
  "selfEffortStatus": "Self-effort status",
  "deliveryTypes": "Delivery types",
  "source": "Source",
  "startDate": "Start date",
  "status": "Status",
  "subProject": "Sub project",
  "supportIntensity": "Support intensity",
  "support-intensity": "Support intensity",
  "targetNumberName": "Target number name",
  "type": "Type",
  "company": "Company",
  "visible": "Visible",
  "move": "Move",
  "workGroup": "Work group",
  "editTabelView": "Edit table view",
  "expandRow": "Show more",
  "collapseRow": "Show less",
  "column": "Column",
  "export": "Export",
  "organization": "Organization",
  "accessType": "Access type",
  "title": "Title",
  "statusName": "Provider type",
  "submittedDate": "Submitted date",
  "municipality": "Municipality",
  "customerName": "Customer name",
  "actorName": "Actor name",
  "actorProfile": "Actor profile",
  "comment": "Comment",
  "referredCorrectly": "Referred correctly",
  "rowCannotBeMarked": "This row cannot be marked",
  "year": "Year",
  "fileName": "Filename",
  "download": "File download",
  "numericId": "ID",
  "companyName": "Company",
  "fromDate": "Contract start",
  "registrationDate": "Registration date",
  "sivaEndDate": "Contract End",
  "preInkFunds": "Preincubation",
  "otherFunds": "Other phases",
  "totalFunds": "Total sum",
  "admissionDate": "Started",
  "portfolioIndustries": "Industries",
  "selfClassification": "Classification",
  "organizationName": "Organization name",
  "selfDeclaration": "Self Declaration",
  "goalAccomplishment": "Goal accomplishment",
  "esa": "ESA",
  "serviceName": "Service name",
  "actor": "Actor",
  "statusProgramHint": "Incubator/Business garden",
  "spentArt28": "Spent art. 28",
  "spentArt28PreInc": "Spent art. 28 (pre inc.)",
  "reportingCompleted": "Reporting done",
  "reportingYearOpen": "Reporting year open",
  "deliveredServices": "Delivered services",
  "contactEmail": "Contact person email",
  "industry": "Industry",
  "invoiceDate": "Invoice date",
  "clusterMemberName": "Name",
  "clusterMemberOrgNo": "Org no.",
  "services": "Services",
  "registeredRecommended": "Registered recommended",
  "dateRecommended": "Date recommended",
  "registeredDelivered": "Registered delivered",
  "dateDelivered": "Date delivered",
  "recommendedStatus": "Recommended status",
  "deliveredStatus": "Delivered status",
  "sendRecommendation": "Send recommendation",
  "markAsRecommended": "Mark as recommended",
  "markAsDelivered": "Mark as delivered"
}
